import { CRM_API, RequestHelper } from "utils";

const RUTA = "cliente";
export const ClienteService = (() => {
  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get("cliente", params);
    });
  };

  const crear = function (data) {
    return new Promise((res) => res(data)).then((data) => {
      return RequestHelper(CRM_API).post("cliente/CrearCliente", data);
    });
  };

  const actualizar = function (clienteData) {
    return new Promise((res) => res(clienteData)).then((clienteData) => {
      return RequestHelper(CRM_API).post(`cliente/${clienteData.IdSec}`, clienteData);
    });
  };

  const buscarPorId = function (Id) {
    return new Promise((res) => res(Id)).then((IdSec) => {
      return RequestHelper(CRM_API).get(`cliente/${IdSec}`);
    });
  };

  const buscarRNC = function (rnc) {
    return new Promise((res) => res(Id)).then((rnc) => {
      return RequestHelper(CRM_API).get(`cliente/${rnc}`);
    });
  };
  
  const listarRNCs = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`cliente/listarRNCs`, params);
    });
  };

  const exportar = function (args) {
    console.log("aca service");
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`cliente/exportar`, params, true);
    });
  };

  return { listado, crear, actualizar, buscarPorId, exportar, listarRNCs, buscarRNC };
})();
